import Jobs from './Jobs';
import JobsSelfEmployed from './JobsSelfEmployed/JobsSelfEmployed';
import { Redirect } from "react-router-dom";
import { useUserPermissions } from "../authorisation/authorisation-hook";

export default function JobsContainer() {
  const { permissions, roles } = useUserPermissions();

  if (!permissions.canViewJobs) {
    return (
        <Redirect to="/bookings" />
    );
  }

  if (roles.isSelfEmployed) {
    return <JobsSelfEmployed />
  }

  return <Jobs />
}
